import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LobbyTabConfig } from '../models/default-lobby-tab';

@Injectable({
  providedIn: 'root'
})
export class LobbySettingsService {
  defaultMerges: LobbyTabConfig[] = [];
  defaultLobbyTabs: LobbyTabConfig[] = [];

  constructor(private translateService: TranslateService) {}

  getDefaultLobbyTabsMerges(): LobbyTabConfig[] { 
    const defaultMerges  = [
      {id: '1', value: this.translateService.instant('_Lobby_Lobby_Queue_Text_')},
      {id: '2', value: this.translateService.instant('_Lobby_Appointment_Queue_Text_')},
      {id: '3', value: this.translateService.instant('_Lobby_Central_Lobby_View_Ts_Text_')},
      {id: '4', value: this.translateService.instant('_Lobby_Central_Staff_Status_View_Ts_Text_')},
      {id: '5', value: this.translateService.instant('_Lobby_Central_Location_View_Ts_Text_')}
    ]
    return defaultMerges;
  } 
  getNewDefaultLobbyTabs(): LobbyTabConfig[] {
    const defaultLobbyTabs  = [
      {id: '1', value: this.translateService.instant('_Lobby_Lobby_Queue_Text_')},
      {id: '2', value: this.translateService.instant('_Lobby_Appointment_Queue_Text_')}
    ]
    return defaultLobbyTabs;
  }


}
